<div id="landing" class="screen">
  <!-- Hero Section -->
  <section
    class="min-h-[80vh] flex flex-col items-center justify-center text-center px-4 md:px-6 py-16 md:py-24 bg-linear-to-br from-flap-black/2 to-signal-orange/5"
  >
    <!-- The board is the headline. Keep a real heading for search engines and
         screen readers, which cannot read a grid of flaps. -->
    <h1 class="sr-only">FlippyBoards - create and share mechanical split-flap displays</h1>

    <!-- Live preview board -->
    <div class="w-full max-w-md sm:max-w-3xl md:max-w-5xl lg:max-w-6xl mb-8">
      <!-- Bezel: light top edge fading to black, a recessed inner lip, and a
           warm spill from the flap-yellow characters -->
      <div
        class="rounded-xl p-3 md:p-6 border border-rail-gray bg-linear-to-b from-rail-gray via-flap-black via-55% to-black shadow-[0_35px_65px_-15px_rgb(0_0_0/0.55),inset_0_3px_8px_rgb(0_0_0/0.7),0_0_120px_-20px_color-mix(in_srgb,var(--color-flap-yellow)_60%,transparent)]"
      >
        <div class="rounded-lg overflow-hidden">
          <app-split-flap-board
            [config]="previewConfig()"
            [messages]="previewMessages()"
            [showHeader]="false"
            [showFooter]="false"
            [compact]="true"
            [muted]="!soundOn()"
            [alphabet]="previewAlphabet"
            [initialRevealMs]="300"
            [pauseWhenNotVisible]="true"
          />
        </div>
      </div>

      <div class="flex justify-end mt-3">
        <button
          type="button"
          (click)="toggleSound()"
          [attr.aria-pressed]="soundOn()"
          class="flex items-center gap-2 text-sm text-rail-gray hover:text-signal-orange transition-colors cursor-pointer"
        >
          <svg
            class="w-4 h-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M11 5 6 9H2v6h4l5 4V5z" />
            @if (soundOn()) {
              <path d="M15.5 8.5a5 5 0 0 1 0 7" />
              <path d="M19 5a9 9 0 0 1 0 14" />
            } @else {
              <path d="m23 9-6 6" />
              <path d="m17 9 6 6" />
            }
          </svg>
          {{ soundOn() ? 'Sound on' : 'Sound off' }}
        </button>
      </div>
    </div>

    <p class="text-xl md:text-2xl text-rail-gray mb-12 max-w-2xl">
      Recreate the nostalgic magic of mechanical split-flap displays. Create custom boards, share
      instantly.
    </p>

    <div class="flex flex-col items-center gap-6">
      <div class="flex flex-col sm:flex-row gap-4">
        <button
          (click)="signUp()"
          class="px-8 py-4 bg-signal-orange text-white rounded-lg font-semibold text-lg hover:bg-signal-orange/90 hover:-translate-y-1 hover:shadow-lg hover:shadow-signal-orange/30 transition-all cursor-pointer"
        >
          Sign Up Free
        </button>
        <button
          (click)="viewDemo()"
          class="px-8 py-4 bg-transparent border-2 border-flap-black text-flap-black rounded-lg font-semibold text-lg hover:bg-flap-black hover:text-station-cream transition-all cursor-pointer"
        >
          View Demo Board
        </button>
      </div>

      <p class="text-rail-gray text-sm">
        Already have an account?
        <button
          (click)="login()"
          class="text-signal-orange font-semibold hover:text-signal-orange/80 hover:underline transition-colors cursor-pointer"
        >
          Log in
        </button>
      </p>
    </div>
  </section>

  <!-- How It Works -->
  <section class="max-w-5xl mx-auto px-4 md:px-6 py-16 md:py-24">
    <div class="text-center mb-16">
      <h2 class="text-4xl md:text-5xl font-bold mb-6">How It Works</h2>
      <p class="text-lg md:text-xl text-rail-gray">
        Create beautiful split-flap displays in three simple steps
      </p>
    </div>

    <div class="grid md:grid-cols-3 gap-8 md:gap-12">
      <div>
        <div
          class="w-12 h-12 bg-signal-orange text-white rounded-full flex items-center justify-center text-2xl font-bold mb-4"
        >
          1
        </div>
        <h3 class="text-xl font-bold mb-2">Configure Your Board</h3>
        <p class="text-rail-gray">Set rows, columns, and customize your display</p>
      </div>
      <div>
        <div
          class="w-12 h-12 bg-signal-orange text-white rounded-full flex items-center justify-center text-2xl font-bold mb-4"
        >
          2
        </div>
        <h3 class="text-xl font-bold mb-2">Add Messages</h3>
        <p class="text-rail-gray">Create a sequence of messages with optional expiration</p>
      </div>
      <div>
        <div
          class="w-12 h-12 bg-signal-orange text-white rounded-full flex items-center justify-center text-2xl font-bold mb-4"
        >
          3
        </div>
        <h3 class="text-xl font-bold mb-2">Share Anywhere</h3>
        <p class="text-rail-gray">Get a unique URL to share your board</p>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <footer class="border-t border-border-subtle px-4 md:px-6 py-8">
    <div
      class="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-rail-gray"
    >
      <p>&copy; 2026 FlippyBoards.com</p>
      <div class="flex gap-6">
        <a routerLink="/terms" class="hover:text-signal-orange hover:underline transition-colors"
          >Terms of Service</a
        >
        <a routerLink="/privacy" class="hover:text-signal-orange hover:underline transition-colors"
          >Privacy Policy</a
        >
      </div>
    </div>
  </footer>
</div>
